import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Typography } from "antd";
import moment from "moment";

import { NavigationPath } from "../../helpers/constants";
import ActionButtons from "../ActionButtons/ActionButtons";

const OfferRequests = ({ state, actions }) => {
  const { offerRequests } = state;
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    actions.getOfferRequests();
  }, []);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelected(selectedRows);
    },
  };

  const navigateToAddOfferRequest = () => {
    navigate(NavigationPath.ADD_OFFER_REQUEST_ROUTE);
  };

  const handleDeleteOfferRequest = () => {
    if (selected) {
      const offerRequestIds = selected.map((offerRequest) => offerRequest.key);
      actions.deleteOfferRequest(offerRequestIds);
      setSelected(null);
    }
  };

  const columns = [
    {
      title: "NASLOV",
      dataIndex: "name",
    },
    {
      title: "Naziv klijenta",
      dataIndex: "client",
    },
    {
      title: "S-Leasing korisnik",
      dataIndex: ["user", "name"],
      responsive: ["sm"],
    },
    {
      title: "Datum zadnje izmjene",
      dataIndex: "updatedAt",
      width: 190,
      responsive: ["lg"],
      sorter: (a, b) => moment(a.updatedAt).diff(moment(b.updatedAt)),
    },
  ];

  return (
    <>
      <div className="px-8 py-4">
        <Typography className="text-xl font-bold text-dark-blue py-1">
          ZAHTJEVI ZA PONUDE
        </Typography>
      </div>
      <div className="h-5 bg-login-white"></div>

      <div className="px-8 py-4">
        <div className="mb-4">
          <ActionButtons
            navigateToAdd={navigateToAddOfferRequest}
            handleDelete={handleDeleteOfferRequest}
            selectedUser={selected}
          />
        </div>
        <Table
          columns={columns}
          dataSource={offerRequests}
          rowSelection={{
            ...rowSelection,
          }}
        />
      </div>
    </>
  );
};

export default OfferRequests;
